<template>
  <span>
    <div id="start_overlay">
        <span id="loading_section" v-show="$store.getters['app/loading']">
            <h1 id="loading_text">Aan het laden...
              <br>
              <span v-show="$store.getters['app/percentageLoad'] != null" v-html="$store.getters['app/percentageLoad']"></span>
            </h1>
        </span>

        <!-- App -->
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 32.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 31.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 27.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 28.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 48.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 29.png">

        <!-- Start -->
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 47.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 42.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 38.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 37.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 36.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 39.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 40.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 35.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 33.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 59.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 4.png">
        <img  class="loaders" @load="addLoader()" src="./../assets/images/Asset 62.png">
        
        <!-- Chinees -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 7.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 5.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 4.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 19.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 17.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 8.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 13.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 18.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 16.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 12.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 14.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 9.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 10.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 11.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 15.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 7.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 5.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 4.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 7.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 5.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 4.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 1.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 3.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 5.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 4.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/chinees/Asset 6.png">

        <!-- Eid -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/eid/Asset 50.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/eid/Asset 48.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/eid/Asset 49.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 57.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">

        <!-- Inheems -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 45_.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 1.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 5.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 11.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 10.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 9.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 8.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 1.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 5.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 1.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 5.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 57.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 1.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 3.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/inheems/Asset 2.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">

        <!-- Kerstmis -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 44_.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 48.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 61.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 63.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 64.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 65.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 72.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 72.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 75.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 71.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 74.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 73.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 68.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 69.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 68.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 77.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 48.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 61.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 4.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 48.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 63.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 64.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 65.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 45_.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 48.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 61.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 78.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 68.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 76.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 77.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 69.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 48.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 49.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/kerstmis/Asset 50.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png" alt="">

        <!-- Keuken -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/keuken/Asset 66.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/keuken/Asset 61.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/keuken/Asset 60.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 57.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">

        <!-- Marron -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/marrons/Asset 0.png" alt="">
        <img class="loaders" @load="addLoader()" src="/static/img/Asset 7.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/marrons/Asset 0.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/marrons/Asset 0.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/marrons/Asset 8.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/marrons/Asset 7.png" alt="">

        <!-- Phagwa -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 45_.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 66.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 71.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 69.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 72.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 64.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 70.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 62.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 65.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 67.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/stokken/Asset 63.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/Asset 49.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/phagwa/Asset 50.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 57.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png" alt="">

        <!-- Vrijheden -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 58.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/vrijheden/Asset 2.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/vrijheden/Asset 1.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 57.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">

    </div>
  </span>
</template>

<script>


export default {
  name: "Preload",

  data() {
    return {
      loader: 0
    };
  },

  methods: {
    addLoader() {
      this.loader++;
    }
  },

  watch: {
    loader(loaded) {
      /**
       * Be sure that this is the exact amount of assets to be loaded
       */
      const total_elements = document.getElementsByClassName('loaders').length;

      this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: parseInt( ( loaded / total_elements ) * 100 ) + ' / 100',
      });

      // If critical assets are loaded, show start button
      if ( loaded == total_elements ) {
        this.$store.dispatch('app/asyncUpdateStarted', {
          started: true,
        });
        this.$store.dispatch('app/asyncUpdateLoading', {
          loading: false,
        });
        this.$router.push('/');

        this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: null,
        });
      }
    }
  },
};
</script>

<style>
  #start_overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #b08f6c;
  }

  .loaders {
    display: none;
  }

  #loading_text {
    font-family: 'LuckiestGuy';
    margin-top: 8%;
    width: 100%;
    height: 20%;
    left: 0%;
    color: white;
    font-size: 5vw;
    text-align: center;
    font-size: 4em;
    color: white;
    z-index: 100;
  }

  #loading_section {
    z-index: 100;
    position: fixed;
    width: 100%;
  }
</style>
